import React, { useState, useRef, useEffect } from "react";
import { Card } from "../Components/cards/Card";
import axios from "axios";
import { NewOrder } from "../Components/ViewModals/NewOrder";
import { Modal } from "react-bootstrap";
import DeliveredOrder from "../Components/ViewModals/DeliveredOrder";
import { ReactComponent as Rounded } from "./../Assets/images/svg/Rounded.svg";
import RoundedImg from "./../Assets/images/Rounded1.png";
import CheckInModel from "../Components/ViewModals/CheckInModel";
import CheckOutModel from "../Components/ViewModals/CheckOutModel";
import { useReactToPrint } from "react-to-print";

//APIS URL
import {
  get_all_orders,
  update_orders_status,
  update_order_prepare,
  room_checkout_detail,
  room_check_out,
  check_in_room,
  refresh_time,
} from "../Pages/apis";

import { data } from "../variables/variables";
import { formatDateTimeWithSeconds } from "../Utils/dateFormat";
import { useOrderRealtime } from "../Utils/useOrderRealtime";

//STYLES FiLES
import "./../Assets/css/main.css";
import "./../Assets/css/Card.css";
import "./../Assets/css/utility.css";
import { AlertModal } from "../Components/ViewModals/Modal";
let dep_id = "";

function Floor_Sidebar({
  roomObj,
  setShowRightSide,
  setRoomObj,
  floors,
  setFloors,
  my_floors,
  getFloors,
  checkOrder,
  setCheckOrder,
}) {
  const [orderModal, setOrderModal] = useState(false);
  const [delivered_order, setDelivered_Order] = useState(false);

  const [allOrders, setAllOrders] = useState([]);
  const ordersRef = useRef([]);
  const [roomsResponse, setRoomsResponse] = useState(false);
  const [display_banner, setDisplay_banner] = useState(false);
  const [order_id, setOrder_id] = useState(0);
  const [prepare, setPrepare] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [st_id, setSt_id] = useState(0);
  const [redirectLogin, setRedirectLogin] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [loading, setLoading] = useState(false);
  const [newOrder, setNewOrder] = useState([]);
  const [check_delivere_detail, setCheck_delivere_detail] = useState([]);
  const [check_deliver_Modal, setcheck_deliver_Modal] = useState(false);
  const [room_id, setRoom_id] = useState("");
  const [session, setSession] = useState({});
  const [room_name, setRoom_name] = useState("");
  const [check_Out_Modal, setcheck_Out_Modal] = useState(false);
  const [check_out_detail, setCheck_out_detail] = useState([]);
  const [checkout_message, setCheckout_Message] = useState("");
  const [checInModel, setCheckInModel] = useState(false);
  const [confirm_disable, setConfirm_Disable] = useState(false);
  const [confirmCheckIn, setConfirmCheckIn] = useState(false);
  const [customer_info, setCustomer_info] = useState({
    name: "",
    phone_number: "",
  });
  const [error, setError] = useState({
    error_name: "",
    error_phone: "",
  });
  const [checkout_Model, setCheckout_Model] = useState(false);
  const invoicePrint = useRef();
  const roomObjRef = useRef(roomObj);

  useEffect(() => {
    roomObjRef.current = roomObj;
  }, [roomObj]);

  //SetHeader Value
  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: "Bearer " + user?.token,
  };
  // "admin" is routed to this same Reception page (see App.js) and should
  // have at least reception-level permissions - otherwise action buttons
  // (Dispatch/Deliver/Check In) silently disappear for admin-logged-in
  // sessions whenever a check only looked for the exact name "reception".
  const isReceptionUser = user?.name === "reception" || user?.name === "admin";
  if (user?.name === "kitchen") {
    dep_id = 3;
  } else {
    dep_id = 2;
  }

  const getOrders = () => {
    const currentRoom = roomObjRef.current;

    if (!dep_id) {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      if (currentUser?.name === "kitchen") {
        dep_id = 3;
      } else {
        dep_id = 2;
      }
    }

    let url = get_all_orders + "/" + dep_id;
    if (currentRoom && currentRoom.id) {
      url += "?room_id=" + currentRoom.id;
    }

    axios
      .get(url, { headers })
      .then((res) => {
        if (res?.data?.status === 200) {
          const orders = res?.data?.orders || [];
          setAllOrders(orders);
          let newOreders = orders;
          newOreders = newOreders.filter((item) => item?.status?.id === 1);
          newOreders = newOreders.map((item) => item?.room?.name);
          const uniqueNames = newOreders.filter(
            (val, id, array) => array.indexOf(val) == id
          );
          setNewOrder(uniqueNames);
        } else {
          console.warn("Orders API returned non-200 status:", res?.data);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setRedirectLogin(true);
        } else {
          console.error("Error fetching orders:", err);
          console.error("Error details:", err?.response?.data);
        }
      });
  };

  useEffect(() => {
    if (checkOrder == true) {
      getOrders();
      setCheckOrder?.(false);
    }
  }, [checkOrder]);

  useEffect(() => {
    getOrders();
  }, []);

  useEffect(() => {
    if (roomObj && roomObj.id && Object.keys(roomObj).length > 0) {
      getOrders();
    }
  }, [roomObj?.id]);

  // Live refresh while this room panel is open. Do not filter by roomId here:
  // getOrders already scopes to the open room, and duplicate room codes can
  // land on a different DB id than the one currently selected.
  useOrderRealtime(
    () => {
      if (roomObjRef.current?.id) {
        getOrders();
      }
    },
    {
      fallbackMs: 3000,
    }
  );

  const AddOrder = (r_code) => {
    setOrderModal(true);
  };

  const handleprint = useReactToPrint({
    content: () => invoicePrint.current,
  });

  const handleDeliverseDetail = () => {
    setcheck_deliver_Modal(true);
    axios
      .get(room_checkout_detail + "/" + roomObj.id, { headers })
      .then((res) => {
        if (res.data.status === 200) {
          setCheck_delivere_detail(res.data.orders);
          setSession(res.data.session);
          setRoom_id(roomObj.id);
        }
      });
  };

  const order_buttons = (ele) => {
    if (ele?.status_id === 1) {
      return (
        <button
          className="button text-bold1"
          onClick={() => updateOrder(ele?.id, ele?.status_id, ele?.room?.name)}
        >
          {data["acknowledge"]}
        </button>
      );
    } else if (
      ele?.status_id === 2 &&
      ele?.prepared === 0 &&
      user?.name === "kitchen"
    ) {
      return (
        <button
          className="success_btn text-bold1"
          onClick={() => OrderPrepare(ele?.id, ele?.status_id, ele?.room?.name)}
        >
          {data["prepared"]}
        </button>
      );
    } else if (
      ele?.status_id === 2 &&
      (ele?.prepared === 1 || isReceptionUser)
    ) {
      return (
        <button
          className="success_btn text-bold1"
          onClick={() => updateOrder(ele?.id, ele?.status_id, ele?.room?.name)}
        >
          {data["dispatch"]}
        </button>
      );
    } else if (
      ele?.status_id === 3 &&
      (ele?.prepared === 1 || isReceptionUser)
    ) {
      return (
        <button
          className="success_btn text-bold1"
          onClick={() => updateOrder(ele?.id, ele?.status_id, ele?.room?.name)}
        >
          {data["deliver"]}
        </button>
      );
    }
  };

  // const receptionBtn =(ele)=>{

  // }

  const updateOrder = (id, status_id) => {
    // setRoom_name(roomName);
    setPrepare(0);
    setShowModal(true);
    status_id++;
    setOrder_id(id);
    setSt_id(status_id);
    setDisplay_banner(false);
  };

  const OrderPrepare = (order_id, status_id, item) => {
    setDisplay_banner(false);
    axios
      .post(update_order_prepare + order_id, { payload: null }, { headers })
      .then((res) => {
        let deepCopy = JSON.parse(JSON.stringify(allOrders));
        if (res.data.status === 200) {
          setPrepare(1);
          setSt_id(status_id);
          setRoom_name(room_name);
          // console.log(res.data)
          deepCopy = deepCopy.map((item) => {
            if (item?.id === order_id) {
              item = { ...item, prepared: 1 };
            }
            return item;
          });
          setAllOrders(deepCopy);
          setDisplay_banner(true);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setRedirectLogin(true);
        } else {
          setSt_id(0);
          setDisplay_banner(true);
        }
      });
  };

  const handleOrder = async (st) => {
    if (st === 1) {
      setLoading(true);
      await axios
        .post(
          update_orders_status + order_id + "/" + st_id,
          { payload: null },
          { headers }
        )
        .then((res) => {
          if (res.data.status === 200) {
            getOrders();
            setShowModal(false);
            setDisplay_banner(true);
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401 || err?.response?.status === 403) {
            setRedirectLogin(true);
          } else {
            setSt_id(0);
            setDisplay_banner(true);
          }
        });
      setLoading(false);
    } else {
      setShowModal(false);
    }
  };

  const handleModal = () => {
    setOrderModal(false);
  };

  const deliveredModal = () => {
    setDelivered_Order(true);
    handleDeliverseDetail();
  };
  const CancelDeliverdModal = () => {
    setDelivered_Order(false);
    setSession({});
  };

  const CancelSidebarModel = () => {
    setShowRightSide(false);
  };
  const handleDelivereDetail = (id) => {
    setcheck_Out_Modal(true);
    axios.get(room_checkout_detail + "/" + id, { headers }).then((res) => {
      if (res.data.status === 200) {
        setCheck_out_detail(res.data.orders);
        setSession(res.data.session);
        // setRoom_id(id);
        // let update_rooms = allRooms.map((item) => {
        //   if (id == item?.id) {
        //     item = { ...item, room_status_id: 2 };
        //   }
        //   return item;
        // });
        // setAllRooms(update_rooms);
      }

      // setCheckout_Model(false);
    });
  };
  const Confirm_checkout = () => {
    setLoading(true);
    setcheck_Out_Modal(true);
    axios.get(room_check_out + "/" + roomObj?.id, { headers }).then((res) => {
      if (res.data.status === 200) {
        setSession(res.data.session);
        // let update_rooms = allRooms.map((item) => {
        //   if (room_id == item?.id) {
        //     item = { ...item, room_status_id: 2 };
        //   }
        //   return item;
        // });
        // setAllRooms(update_rooms);
        getFloors();
        setRoomObj({ ...roomObj, room_status_id: 2 });
        setCheckout_Message("Check Out Successfully");

        setLoading(false);
        setConfirm_Disable(true);
      }

      // setCheckout_Model(false);
    });
  };
  const CancelCheckout_Model = () => {
    // alert("Are u confirm checkout");

    setcheck_Out_Modal(false);
    setRoom_name("");
    setSession({});
    setCheck_out_detail([]);
    setConfirm_Disable(false);
    setCheckout_Message("");
  };
  const CancelCheckin_Model = () => {
    setCheckInModel(false);
    setError({
      error_name: "",
      error_phone: "",
    });
    setCustomer_info({
      name: "",
      phone_number: "",
    });
    // setCheckInModel(false);
  };
  const handlePut = () => {
    console.log("call");
    if (customer_info?.name === "" && customer_info?.phone_number === "") {
      setError({
        error_phone: "Please Enter the customer phone number",
        error_name: "Please Enter the customer name",
      });
      return false;
    } else if (customer_info?.name === "") {
      setError({
        error_phone: "",
        error_name: "Please Enter the customer name",
      });
      return false;
    } else if (customer_info?.phone_number === "") {
      setError({
        error_phone: "Please Enter the customer phone number",
        error_name: "",
      });
      return false;
    }
    let payload = {
      id: room_id,
      customer_information: customer_info,
      check: 0,
    };

    // console.log(my_floors, "bef");
    // let deepCopy = JSON.parse(JSON.stringify(my_floors));
    // deepCopy = deepCopy.map((floor) => {
    //   let roomsCopy = floor;
    //   roomsCopy = roomsCopy.rooms.map((room) => {
    //     if (room?.id == roomObj.id) {
    //       room = { ...room, room_status_id: 1 };
    //     }
    //     return room;
    //   });
    //   return (floor = { ...floor, rooms: roomsCopy });
    // });
    // my_floors = deepCopy;
    // console.log(my_floors, "aft");
    // setFloors(deepCopy);
    // setRoomObj({ ...roomObj, room_status_id: 1 });

    axios.post(check_in_room, { payload }, { headers }).then((res) => {
      if (res.data.status === 200) {
        if (res?.data?.check === true) {
          setCheckInModel(false);
          getFloors();
          setRoomObj({ ...roomObj, room_status_id: 1 });
          setCustomer_info({
            name: "",
            phone_number: "",
          });
          //  setAllRooms(update_rooms);
        } else {
          setCheckInModel(false);
          setConfirmCheckIn(true);
        }
      }
    });
  };
  const handleCancel = () => {
    setCustomer_info({
      name: "",
      phone_number: "",
    });
    setCheckInModel(false);
  };
  const handleCheckInc = () => {
    setCheckInModel(true);
    setRoom_name(roomObj.name);
    setRoom_id(roomObj.id);
  };
  const CancelCustomerName = () => {
    setConfirmCheckIn(false);
  };
  const handleCustomerName = () => {
    // setConfirmCheckIn(true);
    let payload = {
      id: room_id,
      customer_information: customer_info,
      check: 1,
    };
    axios.post(check_in_room, { payload }, { headers }).then((res) => {
      if (res.data.status === 200) {
        setConfirmCheckIn(false);
        getFloors();
        setRoomObj({ ...roomObj, room_status_id: 1 });
        setCustomer_info({
          name: "",
          phone_number: "",
        });
        //  setAllRooms(update_rooms);
      }
    });
  };

  return (
    <>
      {roomObj?.room_status_id === 1 ? (
        <Card>
          <div className="Card_header">
            <div className="card_header_left text-bold">
              <p>{roomObj?.name}</p>
            </div>
            <button className="btn btn-primary" onClick={deliveredModal}>
              Delivered
            </button>
            {user?.name === "kitchen" ? (
              <button
                onClick={() => AddOrder(roomObj?.name, roomObj?.code)}
                className="btn btn-success"
              >
                Add Orders
              </button>
            ) : (
              <div
                className="card_header_right"
                onClick={() => handleDelivereDetail(roomObj?.id)}
              >
                <p className="text-Upper text-bold">{data["check_out"]}</p>
                <Rounded />
              </div>
            )}

            <p
              className="text-bold cursor-pointer cross_sidebar_designe"
              onClick={CancelSidebarModel}
            >
              x
            </p>
          </div>

          {(() => {
            if (!roomObj || !roomObj.id) {
              return (
                <div className="Card_Body">
                  <p className="text-center text-muted">No room selected</p>
                </div>
              );
            }
            
            if (!allOrders || allOrders.length === 0) {
              return (
                <div className="Card_Body">
                  <p className="text-center text-muted">No orders available</p>
                </div>
              );
            }
            
            const filteredOrders = allOrders.filter((ele) => {
              // Filter by room code or room id as fallback
              const matches = (
                (roomObj?.code && ele?.room?.code && String(roomObj.code) === String(ele.room.code)) ||
                (roomObj?.id && ele?.room?.id && Number(roomObj.id) === Number(ele.room.id))
              );
              return matches;
            });
            
            console.log("Filtered orders for room", roomObj?.name || roomObj?.id, ":", filteredOrders.length, "out of", allOrders.length, "total orders");
            console.log("RoomObj details:", { id: roomObj.id, name: roomObj.name, code: roomObj.code });
            if (filteredOrders.length === 0 && allOrders.length > 0) {
              console.log("Sample order room data:", allOrders[0]?.room);
              return (
                <div className="Card_Body">
                  <p className="text-center text-muted">
                    No orders found for {roomObj?.name || "this room"}. 
                    <br />
                    <small>Total orders available: {allOrders.length}</small>
                    <br />
                    <small>Room ID: {roomObj?.id}, Room Code: {roomObj?.code}</small>
                    <br />
                    <small>First order room: ID={allOrders[0]?.room?.id}, Code={allOrders[0]?.room?.code}</small>
                  </p>
                </div>
              );
            }
            
            return filteredOrders.map((ele) => {
                return (
                  <div key={ele?.id} className="Card_Body">
                    <div className="card_body_content">
                      <div className="card_content_left">
                        <h5 className="text-bold1">{data["item"]}</h5>
                        <p>{ele?.menu?.name || "N/A"}</p>
                      </div>
                      <div className="card_content_left1">
                        <h5 className="text-bold1">{data["qty"]}</h5>
                        <p>{ele?.qty || 0}</p>
                      </div>
                      <div className="card_body_centent_center">
                        <h5 className="text-bold1">{data["status"]}</h5>
                        {ele?.status_id === 2 ? (
                          <p>
                            {ele?.prepared === 1
                              ? data["prepared"]
                              : ele?.status?.name || "Acknowledged"}
                          </p>
                        ) : (
                          <p>{ele?.status?.name || "Pending"}</p>
                        )}
                      </div>
                      <div className="card_body_content_right">
                        {order_buttons(ele)}

                        <small>{formatDateTimeWithSeconds(ele?.created_at)}</small>
                      </div>
                    </div>
                  </div>
                );
              });
          })()}
        </Card>
      ) : (
        <Card key={roomObj?.id}>
          <div className="d-flex justify-content-end">
            <p
              className="text-bold cursor-pointer"
              onClick={CancelSidebarModel}
            >
              x
            </p>
          </div>
          <div className="checkIn_body">
            <p className="text-bold">{roomObj?.name}</p>
            {isReceptionUser ? (
              <>
                <div className="card_checkIn" onClick={() => handleCheckInc()}>
                  <p className="text-Upper text-bold">{data["check_in"]}</p>
                  <img src={RoundedImg} alt="logo" />
                </div>
                <small className="text-Upper">{data["check_in_msg"]}</small>
              </>
            ) : (
              ""
            )}
          </div>
        </Card>
      )}

      <AlertModal
        showModal={showModal}
        modalSize="sm"
        animation={false}
        setShowModal={setShowModal}
        handleOrder={handleOrder}
        st_id={st_id}
        loading={loading}
      />

      <Modal show={orderModal} onHide={handleModal}>
        <Modal.Header>
          <p className="text-bold">New Order </p>
          <p className="text-bold cursor-pointer" onClick={handleModal}>
            x
          </p>
        </Modal.Header>
        <Modal.Body>
          <NewOrder
            roomObj={roomObj}
            setOrderModal={setOrderModal}
            // getOrders={getOrders}
            setCheckOrder={setCheckOrder}
          />
        </Modal.Body>
      </Modal>

      <Modal show={delivered_order} onHide={CancelDeliverdModal}>
        <Modal.Header>
          <Modal.Title>Delivered Orders </Modal.Title>
          <p className="text-bold cursor-pointer" onClick={CancelDeliverdModal}>
            x
          </p>
        </Modal.Header>
        <Modal.Body>
          <DeliveredOrder
            room={room_name}
            roomObj={roomObj}
            check_delivere_detail={check_delivere_detail}
            session={session}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="custom_flex justify-content-end">
            <button
              onClick={CancelDeliverdModal}
              className="btn btn-secondary btn-sm active"
              role="button"
            >
              Cancel
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={check_Out_Modal} onHide={setcheck_Out_Modal}>
        <div ref={invoicePrint}>
          <Modal.Header className="headDesigne">
            <h3 className="text-bold ">Invoice Report</h3>
            <p
              className="text-bold cursor-pointer"
              onClick={CancelCheckout_Model}
            >
              x
            </p>
          </Modal.Header>
          {/* check_out_date.check_in; */}
          <Modal.Body>
            <CheckOutModel
              room={room_name}
              check_out_detail={check_out_detail}
              session={session}
            />
          </Modal.Body>
        </div>
        <Modal.Footer>
          <div className="d-flex justify-content-between">
            <p className="text-success mt-3">{checkout_message}</p>
            <div>
              <button
                className="btn btn-danger btn-sm active mt-3 mr-2"
                role="button"
                onClick={Confirm_checkout}
                disabled={confirm_disable}
              >
                {loading ? (
                  <div className="custom_spinner text-light" role="status">
                    {" "}
                  </div>
                ) : (
                  ""
                )}
                Confirm CheckOut
              </button>
              <button
                onClick={handleprint}
                className="btn btn-primary btn-sm active mt-3 mr-2"
                role="button"
              >
                Print
              </button>
              <button
                onClick={CancelCheckout_Model}
                className="btn btn-secondary btn-sm active mt-3"
                role="button"
              >
                Close
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={checInModel} onHide={CancelCheckin_Model}>
        <Modal.Header className="headDesigne">
          <p className="text-bold" blue>
            Customer Entry
          </p>
          <p className="text-bold cursor-pointer" onClick={CancelCheckin_Model}>
            x
          </p>
        </Modal.Header>
        <Modal.Body>
          <CheckInModel
            room={room_name}
            setCustomer_info={setCustomer_info}
            customer_info={customer_info}
            error={error}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="custom_flex justify-content-end mr-5">
            <button
              onClick={handlePut}
              className="btn btn-primary btn-sm active mt-3 mr-2"
              role="button"
            >
              Submit
            </button>
            <button
              onClick={CancelCheckin_Model}
              className="btn btn-secondary btn-sm active mt-3"
              role="button"
            >
              Cancel
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={confirmCheckIn} onHide={CancelCustomerName}>
        <Modal.Body style={{ backgroundColor: "lightgreen" }}>
          <h5 className="text-white text-center">
            Do you want Replace Customer Name With New Name.
          </h5>
          <div className="d-flex justify-content-center mt-4">
            <button className="btn btn-primary" onClick={handleCustomerName}>
              Yes
            </button>
            <button className="btn btn-danger" onClick={CancelCustomerName}>
              No
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default Floor_Sidebar;
